<template>
	<div class="mh-middle">
		<div class="mh-middle-inner">
			<div class="mh-time-top">
				<b-row no-gutters>
					<b-col align-self="center" lg="3" md="12">
						<h2>Time Entries</h2>
					</b-col>
					<b-col align-self="center" lg="9" md="12">
						<div class="mh-time-search">
							<div class="mh-time-search-inner">
								<i class="mh-icon-search"></i>
								<input type="text" placeholder="Search Here..." v-model="search">
							</div>
							<div class="mh-add-entry"><button class="btn btn-default" @click="showAddShiftForm"><i class="mh-icon-plus"></i>Add {{isEmployee ? "Time" : " Service Request"}}</button></div>
						</div>
					</b-col>
				</b-row>
			</div>

			<div v-show="!showForm" class="mh-middle-container">
				<div class="mh-time-entries-top mh-time-off">
					<b-row class="m-0">
						<b-col align-self="center" lg="auto" md="12" class="mb-2 p-0 text-center">
							<div class="mh-entries-nav-container">
								<div class="mh-time-entries-nav">
									<i class="mh-icon-left" @click="pageMonth(-1)"></i>
									<span>{{formattedDate}}</span>
									<i class="mh-icon-right" @click="pageMonth(1)"></i>
								</div>
							</div>
						</b-col>
						<b-col align-self="center" lg="2" md="12" class="ml-auto mb-2 p-0">
							<div class="switches-container">
								<input type="radio" id="all" value="all" checked="checked" v-model="fortnight" @change="setFortnight" />
								<input type="radio" id="fortnight" value="fortnight" v-model="fortnight" @change="setFortnight" />
								<label for="all">All</label>
								<label for="fortnight">Fortnight</label>
								<div class="switch-wrapper">
									<div class="switch">
										<div>All</div>
										<div>Fortnight</div>
									</div>
								</div>
							</div>
						</b-col>
						<b-col align-self="center" lg="auto" md="12" class="mb-2 p-0">
							<div class="mh-time-entries-dates">
								<div class="mh-datepicker">
									<datepicker v-model="date" @input="setDate" />
									<i class="mh-icon-calendar"></i>
								</div>
							</div>
						</b-col>
						<b-col align-self="center" lg="auto" md="12" class="mb-2 p-0">
							<b-select class="btn-select" v-model="months" @change="setMonth">
								<b-form-select-option value="0">January</b-form-select-option>
								<b-form-select-option value="1">February</b-form-select-option>
								<b-form-select-option value="2">March</b-form-select-option>
								<b-form-select-option value="3">April</b-form-select-option>
								<b-form-select-option value="4">May</b-form-select-option>
								<b-form-select-option value="5">June</b-form-select-option>
								<b-form-select-option value="6">July</b-form-select-option>
								<b-form-select-option value="7">August</b-form-select-option>
								<b-form-select-option value="8">September</b-form-select-option>
								<b-form-select-option value="9">October</b-form-select-option>
								<b-form-select-option value="10">November</b-form-select-option>
								<b-form-select-option value="11">December</b-form-select-option>
							</b-select>
						</b-col>
						<b-col align-self="center" lg="auto" md="12" class="mb-2">
							<a title="Reset filters"><i class="mh-icon-undo round-icon-button" :disabled="!isFiltered" @click="resetFilters"></i></a>
						</b-col>

						<b-col v-if="records.length != 0" cols="12" class="p-0 mt-3">
							<div class="table-reponsive mh-entries-list">
								<div class="dataTables_wrapper no-footer">
									<data-table v-bind="bindings"
												:showPerPage="false"
												:showEntriesInfo="false"
												:showSearchFilter="false"
												:showPagination="true"
												:showDownloadButton="false"
												:text="{ emptyTableText: '' }"
												sortingMode="single"
												tableClass="table table-curved dataTable light"
												ref="dataTable" />
								</div>
							</div>
						</b-col>
						<b-col v-else cols="12" class="no-time-entries-container text-center p-0 pt-4">
							<img src="../assets/images/no-time-entries.png" class="mb-5" />
							<div class="title mb-2">No Time For This Month</div>
							<div class="text mb-4"><a href="#" @click="showAddShiftForm">Add Time</a>, No Time For This Month</div>
							<b-button class="btn-default btn-green p-3" @click="pageMonth(-1)"><i class="mh-icon-left mr-2"></i> Go To {{moment(this.date).add(-1, "months").format("MMMM")}}</b-button>
						</b-col>
					</b-row>
				</div>
			</div>

			<div ref="forms" v-if="showForm">
				<b-card no-body class="mh-card mh-card-page">
					<b-card-header class="mh-bg-primary d-flex align-items-center">
						<h3 class="card-title">{{isEmployee ? "Timesheet Editor" : "Service Request"}}</h3>
						<b-col cols="auto" class="ml-auto p-0">
							<button type="button" class="btn btn-link mh-btn-icon" @click="closeForm"><i class="mh-icon-close"></i></button>
						</b-col>
					</b-card-header>
					<b-card-body class="mh-off-middle pl-2 pr-2">
						<TimesheetForm v-if="isEmployee" @close-form="closeForm" @save-form="saveForm" :data="selectedRecord" />
						<ShiftForm v-else @close-form="closeForm" @save-form="saveForm" :data="selectedRecord" />
					</b-card-body>
				</b-card>
			</div>
		</div>
	</div>
</template>

<script>
	import ContentTitle from "./partials/ContentTitle"
	import SortingIcon from "./partials/SortingIcon"
	import HtmlColumn from "./partials/HtmlColumn"
	import ShiftForm from "./partials/ShiftForm"
	import TimesheetForm from "./partials/TimesheetForm"
	import TableRowActions from "./partials/TableRowActions"
	import { bus } from "./../main"
	import moment from "moment"

	export default {
		name: 'TimeEntriesContent',
		components: {
			ShiftForm,
			TimesheetForm,
			ContentTitle,
			SortingIcon,
			HtmlColumn,
			TableRowActions
		},
		data: function () {
			return {
				search: "",
				isFiltered: false,
				editing: false,
				adding: false,
				selectedRecord: null,
				isMonth: true,
				fortnight: "fortnight",
				date: new Date(),
				months: new Date().getMonth(),
				type: "Time In / Out",
				timeInDate: new Date(),
				timeInTime: {
					hh: "00",
					mm: "00",
					a: "am"
				},
				timeOutDate: new Date(),
				timeOutTime: {
					hh: "00",
					mm: "00",
					a: "am"
				},
				totalHours: "",
				customerId: null,
				itemId: null,
				notes: null,
				travelKm: 0,
				transportKm: 0
			}
		},
		mounted: function () {
			this.date = this.dateFrom

			this.getShifts()

			bus.$off('editDetailsTableRowAction')
			bus.$on('editDetailsTableRowAction', obj => { this.editRow(obj) })

			bus.$off('deleteDetailsTableRowAction')
			bus.$on('deleteDetailsTableRowAction', obj => { this.deleteRow(obj) })
		},
		watch: {
			search: {
				immediate: true,
				handler(newValue, oldValue) {
					if (this.$refs.dataTable != null) {
						this.$refs.dataTable.search = newValue
						this.$refs.dataTable.setSearch()
					}
				}
			}
		},
		computed: {
			profile: function () {
				return this.$store.state.Profile.profile
			},
			shifts: function () {
				return this.$store.state.Shifts.shifts
			},
			dateFrom: function () {
				return this.$store.state.Shifts.date
			},
			records: function () {
				return JSON.parse(JSON.stringify(this.shifts))
					.sort(this.$store.getters["Helper/compareValues"](
						"servicedate",
						"desc",
						(val) => { return moment(val, "D/MM/YYYY h:mm:ss A").toDate() }))
					.map(x => {
						var startTime = moment(x.servicedate, "D/MM/YYYY h:mm:ss A").format("DD-MM-YYYY HH:mm:ss")
						var endTime = moment(x.enddate, "D/MM/YYYY h:mm:ss A").format("DD-MM-YYYY HH:mm:ss")
						var start = moment(x.servicedate, "D/MM/YYYY h:mm:ss A").format("HH:mm")
						var end = startTime == endTime && x.istimeclock ? "Now" : moment(x.enddate, "D/MM/YYYY h:mm:ss A").format("HH:mm")
						var customer = (this.isEmployee ? x.clientfullname : x.shifttask)
						var name = this.isEmployee ? x.shifttask : x.clientfullname

						return {
							id: x.servicescheduleid,
							name: customer,
							item: name,
							date: moment(x.servicedate, "D/MM/YYYY h:mm:ss A").format("DD MMM, ddd"),
							time: `${start} - ${end} (${this.$store.getters["Helper/getShortDuration"](startTime, endTime, false)})`,
							location: x.clientfulladdress,
							notes: x.shiftnotes,
							timesheetApproved: x.timesheetapproved,
							serviceScheduleId: x.servicescheduleid,
							timesheetId: x.timesheetid,
							style: x.errors.length > 0 ? "color: #ff0000;" : "",
							error: x.errors,
							icons: [
								{
									class: "mh-icon-edit",
									title: "Edit",
									emit: "editDetailsTableRowAction"
								},
								{
									class: "trash-alt",
									title: "Delete",
									emit: "deleteDetailsTableRowAction"
								}
							]
						}
					})
					.filter(x => {
						return (x.name + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
							|| (x.time + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
							|| (x.duration + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
							|| (x.customer + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
							|| (x.location + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
							|| (x.notes + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
					})
			},
			columns: function () {
				var columns = [
					{ key: "date", title: "Date", searchable: true, sortable: true, component: HtmlColumn, sortingFunction: function (a, b) { return moment(b.date, "D/MM/YYYY h:mm:ss A").toDate() - moment(a.date, "D/MM/YYYY h:mm:ss A").toDate(); } },
					{ key: "time", title: "Time In-Out", searchable: true, sortable: true, component: HtmlColumn },
					{ key: "name", title: "Name", searchable: true, sortable: true, component: HtmlColumn, style: "display: block;width:10vw;" },
					{ key: "item", title: "Item", searchable: true, sortable: true, component: HtmlColumn, style: "display: block;width:15vw;" },
					{ key: "location", title: "Location", searchable: true, sortable: true, component: HtmlColumn, style: "display: block;width:10vw;" },
					{ key: "notes", title: "Notes", searchable: true, sortable: true, component: HtmlColumn, style: "display: block;width:10vw;" },
					{ key: "", title: "", component: TableRowActions }
				]

				return columns
			},
			bindings: function () {
				return {
					SortingIconComponent: SortingIcon,
					columns: this.columns,
					data: this.records
				}
			},
			formattedDate: function () {
				var date = moment(this.date).format("DD MMMM YYYY")

				if (this.isMonth)
					date = moment(this.date).format("MMMM YYYY")

				if (this.fortnight === "fortnight")
					date = `${moment(this.date).format("DD MMM")} - ${moment(this.date).add(-1, "days").add(2, "weeks").format("DD MMM")}`

				return date
			},
			showForm: function () {
				return this.adding || this.editing
			},
			isEmployee: function () {
				return this.profile.accounttype == 2
			}
		},
		methods: {
			getShifts: function () {
				return new Promise((resolve, reject) => {
					var startDate = moment(this.date)
					var endDate = moment(this.date)

					if (this.isMonth) {
						startDate = moment(this.date).startOf('month')
						endDate = moment(this.date).endOf('month')
					}

					if (this.fortnight === "fortnight") {
						startDate = moment(this.date)
						endDate = moment(this.date).add(14, "days")
					}

					this.$store.dispatch(
						"Shifts/getShiftsForRange",
						{
							fromDate: startDate.format('YYYY-MM-DD'),
							toDate: endDate.format('YYYY-MM-DD'),
							showLoading: false
						}
					)
						.then(function () {
							resolve()
						})
						.catch(function (exception) {
							reject(exception)
						})
				})
			},
			resetFilters: function () {
				this.isFiltered = false
				this.isMonth = true
				this.fortnight = "fortnight"

				this.getShifts()
			},
			pageMonth: function (i) {
				var duration = "months"

				if (this.fortnight === "fortnight") {
					i = 2 * i
					duration = "weeks"
				}

				if (this.isFiltered)
					duration = "days"

				this.date = moment(this.date).add(i, duration).toDate()
				this.months = this.date.getMonth()

				this.$store.commit("Shifts/setDate", this.date)

				this.getShifts()
			},
			setDate: function (date) {
				this.isFiltered = true
				this.isMonth = false
				this.fortnight = "fortnight"
				this.date = date
				this.months = date.getMonth()

				this.$store.commit("Shifts/setDate", this.date)

				this.getShifts()
			},
			setMonth: function (month) {
				this.isFiltered = false
				this.isMonth = true
				this.fortnight = "all"
				this.date = moment(this.date).set("month", month).toDate()
				this.months = this.date.getMonth()

				this.$store.commit("Shifts/setDate", this.date)

				this.getShifts()
			},
			setFortnight: function () {
				if (this.fortnight === "all") {
					if (this.isFiltered)
						this.setDate(this.date)

					if (this.isMonth)
						this.setMonth(this.date.getMonth())

					return
				}

				this.getShifts()
			},
			showAddShiftForm: function () {
				this.selectedRecord = null

				this.adding = true
			},
			closeForm: function () {
				this.selectedRecord = null

				this.adding = false
				this.editing = false
			},
			saveForm: function () {
				this.getShifts()
			},
			editRow: function (obj) {
				var $this = this

				this.getShifts().then(function () {
					$this.selectedRecord = $this.shifts.filter(x => x.servicescheduleid == obj.id)[0]

					$this.editing = true

					window.scrollTo(0, 300)
				})
			},
			deleteRow: function (obj) {
				if (obj.timesheetApproved == "True") {
					this.$store.commit("Toasts/showWarning", { title: "Shift", content: "Shift is approved and cannot be deleted!" })

					return
				}

				this.$store.commit("Confirmation/show", {
					text: `Are you sure you want to delete <b>${obj.name}</b> on <b>${obj.date}</b> at <b>${obj.time}</b>?`,
					okCallback: () => {
						this.$store.dispatch(
							"Shifts/DeleteShift",
							{
								timesheetId: obj.timesheetId,
								serviceScheduleId: obj.serviceScheduleId
							})
							.then(() => {
								this.getShifts()
							})
					},
					cancelCallback: null
				})
			}
		}
	};
</script>

<style>
	.mh-time-entries-dates .mh-datepicker input {
		margin: 0 !important;
		padding-left: 70px !important;
	}

	
</style>

<style scoped>
	.switches-container {
		right: 15px;
		margin-bottom: 0;
	}

	.mh-time-entries-dates .mh-datepicker {
		margin-right: 15px;
	}
</style>